export enum Confederation {
	AFC = "afc",
	UEFA = "uefa",
	CONMEBOL = "conmebol",
}

export enum Groups {
	A = "a",
	B = "b",
	C = "c",
	D = "d",
	E = "e",
	F = "f",
	G = "g",
	H = "h",
}

export enum Pots {
	POT1 = "1",
	POT2 = "2",
	POT3 = "3",
	POT4 = "4",
}

export enum FanDrawType {
	PostDraw = "post_draw",
	PostDrawQualTeams = "post_draw_qual_teams",
	PreDraw = "pre_draw",
	PreDrawQualTeams = "pre_draw_qual_teams",
}

export enum PreDrawGroupType {
	Binary = "binary",
	Multiple = "multiple",
}
